var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53979 4.97917L0.311667 8.2075C0.103889 8.41514 0 8.655 0 8.92708C0 9.19917 0.103889 9.43903 0.311667 9.64667C0.519306 9.85444 0.759167 9.95833 1.03125 9.95833C1.30333 9.95833 1.54556 9.85215 1.75792 9.63979L5.6975 5.70021C5.79042 5.6016 5.8641 5.48896 5.91854 5.36229C5.97285 5.23549 6 5.10639 6 4.975C6 4.84361 5.97285 4.71451 5.91854 4.58771C5.8641 4.46104 5.79042 4.35118 5.6975 4.25813L1.75792 0.318541C1.54556 0.10618 1.30333 0 1.03125 0C0.759167 0 0.519306 0.103889 0.311667 0.311667C0.103889 0.519306 0 0.759167 0 1.03125C0 1.30333 0.103889 1.54319 0.311667 1.75083L3.53979 4.97917Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.189d8453149e61da08f7b9197b54fda7.svg";
export { ForwardRef as ReactComponent };